
    import Component from "vue-class-component"
    import {Prop} from "vue-property-decorator";
    import Vue from 'vue';

    @Component
    export default class Badge extends Vue {
        @Prop({required: true})
        type!: string;
        @Prop({required: true})
        text!: string;
    }
